import { moveToOnboarding } from '../../../../services/popupApi';

export const api = {
  submit: async (values, context) => {
    await moveToOnboarding({
      submissionId: context.selectedRecords?.[0]?.submissionId,
      isMail: values.sendOnboardingEmail,
    });
  },
};
